import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const SMuiTextField = styled(MuiTextField)(({ theme }) => ({
  '& fieldset': {
    '& legend': {
      width: 'unset',
    },
  },
}));

const TextField = (props) => {
  return <SMuiTextField {...props} />;
};

export default TextField;
